import { fetchAllEventsCount } from 'actions';
import LinkLookup from 'components/LinkLookup';
import Permissions from 'components/Permissions';
import withWidget from 'decorators/widget';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUser } from 'selectors/auth';
import { getPermissionsPolicy } from 'selectors/permissions';
import { useSelector } from 'store';
import logEvent from 'utils/analytics';
import { isActionAuthorized } from 'utils/permissions';
import { useTimeRange } from 'utils/timeRanges';

const ViewEvents: React.FC = () => {
  const dispatch = useDispatch();

  const user = useSelector(getUser);
  const policy = useSelector(getPermissionsPolicy);

  const range = useTimeRange();

  const buttonClass = 'focus:outline-none hover:outline-none hover:underline text-white';

  useEffect(() => {
    dispatch(fetchAllEventsCount(range));
  }, [dispatch, range]);

  const renderLinkBody = (
    <div className="flex h-full items-center justify-between">
      <div className="text text--left text-2xl text--white">Create New Search</div>
      <Permissions action="events.list">
        <div className="flex flex-row items-center">
          <svg
            className="h-10 w-10 text text--bold text--white"
            fill="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </div>
      </Permissions>
    </div>
  );

  return (
    <div className="overview-items-container border-transparent w-full">
      {isActionAuthorized('events.list', user.roles, policy) ? (
        <LinkLookup
          className={buttonClass}
          routeName="envelope-list"
          onClick={(): Promise<void> => logEvent('Dashboard-new-search')}
        >
          {renderLinkBody}
        </LinkLookup>
      ) : (
        <button
          className={`${buttonClass} pointer-events-none cursor-default no-underline`}
          type="button"
        >
          {renderLinkBody}
        </button>
      )}
    </div>
  );
};

export default withWidget({
  minWidth: 5,
  minHeight: 3,
  bgClassColor: 'bg-litlingo-primary',
})(ViewEvents);
